import {
  ADD_TO_CART,
  GET_USER_CART_ITEMS,
  DELETE_ALL_CART_ITEMS,
  REMOVE_ONE_ITEM,
  UPDATE_ITEM_CART,
  APPLY_COUPON,
  ADMIN_ALL_CARTS,
  SEND_EMAIL,
  SELECTED_VARIANT,
  NOT_LOGIN_ADD_TO_CART,
  STORE_NOT_LOGIN_CART_ITEMS,
  ADD_CART_ATTACHMENT,
} from "../type";
import { useInsertData, useInsertDataWithImage } from "../../hooks/useInsertData";
import { useGetData, useGetDataToken } from "../../hooks/useGetData";
import useDeleteData from "../../hooks/useDeleteData";
import { useUpdateData } from "../../hooks/useUpdateData";

export const addProductToCart = (body) => async (dispatch) => {
  try {
    const response = await useInsertData(`/api/v1/cart/website`, body);
    dispatch({
      type: ADD_TO_CART,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: ADD_TO_CART,
      payload: error,
    });
  }
};

export const getAllCartItems = (id) => async (dispatch) => {
  try {
    const response = await useGetDataToken(`/api/v1/cart/website/${id}`);
    dispatch({
      type: GET_USER_CART_ITEMS,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: GET_USER_CART_ITEMS,
      payload: error,
    });
  }
};

export const removeAllCartItems = (id) => async (dispatch) => {
  try {
    const response = await useDeleteData(`/api/v1/cart/remove/${id}`);
    dispatch({
      type: DELETE_ALL_CART_ITEMS,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: DELETE_ALL_CART_ITEMS,
      payload: error,
    });
  }
};

export const removeOneItem = (id) => async (dispatch) => {
  try {
    const response = await useDeleteData(`/api/v1/cart/${id}`);
    dispatch({
      type: REMOVE_ONE_ITEM,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: REMOVE_ONE_ITEM,
      payload: error,
    });
  }
};

export const updateItemCart = (id, body) => async (dispatch) => {
  try {
    const response = await useUpdateData(`/api/v1/cart/webiste/${id}`, body);
    dispatch({
      type: UPDATE_ITEM_CART,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_ITEM_CART,
      payload: error,
    });
  }
};

// apply coupon
export const applyCoupon = (title, body) => async (dispatch) => {
  try {
    const response = await useUpdateData(
      `/api/v1/coupons/website/${title}`,
      body
    );
    dispatch({
      type: APPLY_COUPON,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: APPLY_COUPON,
      payload: error,
    });
  }
};

// admin all cart
export const adminAllCart = () => async (dispatch) => {
  try {
    const response = await useGetDataToken(`/api/v1/cart`);
    dispatch({
      type: ADMIN_ALL_CARTS,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: ADMIN_ALL_CARTS,
      payload: error,
    });
  }
};

export const sendEmail = (body) => async (dispatch) => {
  try {
    const response = await useInsertData(
      `/api/v1/cart/website/sendEmail`,
      body
    );
    dispatch({
      type: SEND_EMAIL,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: SEND_EMAIL,
      payload: error,
    });
  }
};

export const setSelectedVariant = (variant) => {
  return {
    type: SELECTED_VARIANT,
    payload: variant,
  };
};

export const notLoginAddItemToCart =
  ({ numberOfItems }) =>
  async (dispatch) => {
    try {
      // console.log('numberOfItems action',numberOfItems);

      dispatch({
        type: NOT_LOGIN_ADD_TO_CART,
        payload: numberOfItems,
      });
    } catch (error) {
      console.log("error in notLoginAddToCart action", error.message);
    }
  };

export const storeNotLoginCartItems =
  ({ items }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: STORE_NOT_LOGIN_CART_ITEMS,
        payload: items,
      });
    } catch (error) {
      console.log("error in storeNotLoginCartItems action", error.message);
    }
  };

export const storeNotLoginCartInBackEnd =
  ({ items, user }) =>
  async (dispatch,getState) => {
    try {
      

      for (let cart of items) {
        console.log("cart item", cart);

        let dispatchObj = {
          product: cart?.product?._id,
          user: user?._id,
          // color: colorText,
          // classification: sizeText,
          quantity: cart.quantity,
        };

        if (cart?.color) {
          dispatchObj.color = cart.color;
        }
        if (cart?.classification) {
          dispatchObj.classification = cart.classification;
        }

        if (cart?.priceAfter) {
          // *  Number(cart.quantity)
          dispatchObj.priceAfter = Number(cart?.priceAfter) ;
        }

        // if (item.hasVariant) {
        //   //منتج عليه عرض
        //   let variant = {};

        //   if (selectedVariant._id)
        //     variant = item.variants.find(el => el._id == selectedVariant._id);
        //   else
        //     variant = item.defaultVariant;
        //   // if(item.Offer!=null)
        //   // {
        //   //   defaultVariant.price=calculatePriceForVariant(item,item.defaultVariant);
        //   // }

        //   dispatchObj.variant = variant;
        // }

        await dispatch(addProductToCart(dispatchObj));
      }

      // remove cart from local storage here
       localStorage.removeItem("cart");

    } catch (error) {
      console.log("error in storeNotLoginCartInBackEnd action", error.message);
    }
  };

export const addCartAttachment = (id, formData) => async (dispatch) => {
  try {
    const response = await useInsertDataWithImage(`/api/v1/cart/addAttachment/${id}`, formData);
    dispatch({
      type: ADD_CART_ATTACHMENT,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: ADD_CART_ATTACHMENT,
      payload: error,
    });
  }
};
